import { render, staticRenderFns } from "./CreateNewTeamForm.vue?vue&type=template&id=f8f6386e"
import script from "./CreateNewTeamForm.vue?vue&type=script&lang=js"
export * from "./CreateNewTeamForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports